import {Injectable, Pipe, PipeTransform} from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslocoService } from '@ngneat/transloco';
import {localizedDateString} from "@utility";

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'localizedDate', pure: false,
    standalone: false
})
export class LocalizedDatePipe extends DatePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {
    super(translocoService.getActiveLang());
  }

  override transform = (value: any, format = 'short'): any => {
    return localizedDateString(value, format, this.translocoService.getActiveLang());
  };
}
